/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getKpisTechnicien } from '../fn/kpis-technicien-controller/get-kpis-technicien';
import { GetKpisTechnicien$Params } from '../fn/kpis-technicien-controller/get-kpis-technicien';
import { KpisTechnicienResponseDto } from '../models/kpis-technicien-response-dto';

@Injectable({ providedIn: 'root' })
export class KpisTechnicienControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getKpisTechnicien()` */
  static readonly GetKpisTechnicienPath = '/v1/kpisTechnicien/techniciens/{id_technicien}/year/{year}/week/{week}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getKpisTechnicien()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKpisTechnicien$Response(
    params: GetKpisTechnicien$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<KpisTechnicienResponseDto>> {
    return getKpisTechnicien(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getKpisTechnicien$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKpisTechnicien(params: GetKpisTechnicien$Params, context?: HttpContext): Observable<KpisTechnicienResponseDto> {
    return this.getKpisTechnicien$Response(params, context).pipe(
      map((r: StrictHttpResponse<KpisTechnicienResponseDto>): KpisTechnicienResponseDto => r.body)
    );
  }
}
